export default __webpack_public_path__ + "static/media/hover.9d12eec1.wav";